<script setup>
import { cookies, policy } from '@/actions/App/Http/Controllers/LawController'
import { about, contacts, home } from '@/actions/App/Http/Controllers/PageController'
import ProjectController from '@/actions/App/Http/Controllers/ProjectController'
import { blownInsulation, drywall, screed } from '@/actions/App/Http/Controllers/ServiceController'
import FooterLudwig from '@/Layouts/Partials/FooterLudwig.vue'
import { router, usePage } from '@inertiajs/vue3'
import { computed, defineComponent, h } from 'vue'

const page = usePage()

const navigation = computed(() => ({
    homepages: [
        {
            name: 'Úvod',
            href: home.url(),
        },
        {
            name: 'Stavby',
            href: ProjectController.index.url(),
        },
        {
            name: 'O nás',
            href: home.url() + '#o-nas',
        },
        {
            name: 'Služby',
            href: home.url() + '#sluzby',
        },
        {
            name: 'Kontakt',
            href: home.url() + '#kontakt',
        },
        {
            name: 'F&Q',
            href: home.url() + '#faq',
        },
    ],
    services: [
        {
            name: 'Montáže sádrokartonu',
            href: drywall.url(),
        },
        {
            name: 'Foukaná izolace',
            href: blownInsulation.url(),
        },
        {
            name: 'Betonové stěrky',
            href: screed.url(),
        },
    ],

    abouts: [
        {
            name: 'O firmě',
            href: about.url(),
            target: '_self',
            rel: 'opener referrer',
        },
        {
            name: 'Instagram',
            href: page.props.socials?.instagram || '#',
            target: '_blank',
            rel: 'noopener noreferrer',
        },
        {
            name: 'Facebook',
            href: page.props.socials?.facebook || '#',
            target: '_blank',
            rel: 'noopener noreferrer',
        },
        {
            name: 'YouTube',
            href: page.props.socials?.youtube || '#',
            target: '_blank',
            rel: 'noopener noreferrer',
        },
        {
            name: 'TikTok',
            href: page.props.socials?.tiktok || '#',
            target: '_blank',
            rel: 'noopener noreferrer',
        },
    ],

    contacts: [
        {
            name: 'Kontaktní formulář',
            href: contacts.url() + '#kontaktni-formular',
        },
        {
            name: page.props.contacts?.[0]?.email || '',
            href: 'mailto:' + (page.props.contacts?.[0]?.email || ''),
        },
        {
            name: page.props.contacts?.[0]?.phone || '',
            href: 'tel:' + (page.props.contacts?.[0]?.phone || ''),
        },
        {
            name: page.props.contacts?.[1]?.email || '',
            href: 'mailto:' + (page.props.contacts?.[1]?.email || ''),
        },
        {
            name: page.props.contacts?.[1]?.phone || '',
            href: 'tel:' + (page.props.contacts?.[1]?.phone || ''),
        },
        {
            name: page.props.accountant?.email || '',
            href: 'mailto:' + (page.props.accountant?.email || ''),
        },
        {
            name: page.props.accountant?.phone || '',
            href: 'tel:' + (page.props.accountant?.phone || ''),
        },
    ],

    socials: [
        {
            name: 'Facebook',
            href: page.props.socials?.facebook || '#',
            icon: defineComponent({
                render: () =>
                    h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                        h('path', {
                            'fill-rule': 'evenodd',
                            d: 'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z',
                            'clip-rule': 'evenodd',
                        }),
                    ]),
            }),
        },
        {
            name: 'Instagram',
            href: page.props.socials?.instagram || '#',
            icon: defineComponent({
                render: () =>
                    h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                        h('path', {
                            'fill-rule': 'evenodd',
                            d: 'M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z',
                            'clip-rule': 'evenodd',
                        }),
                    ]),
            }),
        },
        {
            name: 'YouTube',
            href: page.props.socials?.youtube || '#',
            icon: defineComponent({
                render: () =>
                    h(
                        'svg',
                        {
                            version: '1.0',
                            xmlns: 'http://www.w3.org/2000/svg',
                            viewBox: '0 0 512 512',
                            fill: 'currentColor',
                            class: 'size-6',
                            'aria-hidden': 'true',
                        },
                        [
                            h(
                                'g',
                                {
                                    transform: 'translate(0.000000,512.000000) scale(0.100000,-0.100000)',
                                    fill: 'currentColor',
                                    stroke: 'none',
                                },
                                [
                                    h('path', {
                                        d: 'M1710 4339 c-523 -15 -1002 -54 -1154 -94 -102 -27 -194 -82 -282 -170 -127 -126 -172 -236 -214 -524 -98 -677 -68 -1874 57 -2252 74 -224 248 -379 488 -432 574 -128 3380 -126 3924 3 122 29 231 90 318 176 144 144 196 312 238 775 68 749 20 1746 -98 2037 -85 212 -257 356 -472 397 -415 77 -1697 116 -2805 84z m1007 -1396 c359 -207 653 -379 653 -382 -1 -6 -1304 -761-1314 -761 -3 0 -6 342 -6 760 0 418 3 760 7 760 3 0 300 -170 660 -377z',
                                    }),
                                ]
                            ),
                        ]
                    ),
            }),
        },
        {
            name: 'TikTok',
            href: page.props.socials?.tiktok || '#',
            icon: defineComponent({
                render: () =>
                    h('svg', { fill: 'currentColor', viewBox: '0 0 32 32', xmlns: 'http://www.w3.org/2000/svg' }, [
                        h('path', {
                            d: 'M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z',
                        }),
                    ]),
            }),
        },
    ],
}))

function openCookiePreferences() {
    if (typeof window.showHideToggleCookiePreferencesModal === 'function') {
        window.showHideToggleCookiePreferencesModal()

        return
    }

    router.visit(cookies.url())
}
</script>

<template>
    <footer class="section-width !mx-0 mb-2 !max-w-none md:mx-2 lg:!mb-5 xl:!mx-5">
        <div class="rounded-[2.5rem] bg-black/50">
            <div class="section-width lg:py-8">
                <div class="mx-auto max-w-2xl text-center">
                    <hgroup>
                        <h2 class="text-brand-orange font-chivo text-xl font-semibold uppercase">Kontaktní formulář</h2>
                        <p class="mt-2 text-2xl font-semibold tracking-tight text-balance text-gray-100 sm:text-3xl">
                            Pokud máte zájem o naše služby, neváhejte nás kontaktovat prostřednictvím kontaktního
                            formuláře.
                        </p>
                    </hgroup>
                    <div class="mt-8 flex justify-center">
                        <Link
                            :href="contacts.url() + '#kontaktni-formular'"
                            aria-label="Vyplnit formulář"
                            class="bg-brand-orange border-brand-orange hover:bg-brand-orange/80 w-full cursor-pointer rounded-full border px-5 py-4 text-center text-white backdrop-blur-3xl transition-all duration-150 ease-in-out xl:py-2"
                        >
                            Vyplnit formulář
                        </Link>
                    </div>
                </div>

                <div class="border-brand-orange/50 mt-24 grid grid-cols-1 border-t pt-12 xl:grid-cols-3 xl:gap-8">
                    <div class="mx-auto lg:mx-auto xl:ml-auto xl:w-full">
                        <img
                            class="h-24 w-auto"
                            src="/src/logo/logo.png"
                            alt="logo - J&M.Sádrokartony s.r.o."
                        />
                    </div>

                    <div
                        class="mt-16 grid grid-cols-2 place-items-center items-start gap-8 lg:place-items-stretch xl:col-span-2 xl:mt-0"
                    >
                        <div class="grid h-full md:gap-8 lg:grid-cols-2">
                            <div class="">
                                <h3 class="text-left text-sm/6 font-semibold text-white">Domovská stránka</h3>
                                <ul
                                    role="list"
                                    class="mt-6 space-y-2 pl-2"
                                >
                                    <li
                                        v-for="item in navigation.homepages"
                                        :key="item.name"
                                    >
                                        <a
                                            :href="item.href"
                                            :arial-label="'Odkaz ' + item.name"
                                            class="text-xs text-gray-200 hover:underline md:text-sm/6"
                                        >
                                            {{ item.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="mt-10 md:mt-0">
                                <h3 class="text-left text-sm/6 font-semibold text-white">Služby</h3>
                                <ul
                                    role="list"
                                    class="mt-6 space-y-2 pl-2"
                                >
                                    <li
                                        v-for="item in navigation.services"
                                        :key="item.name"
                                    >
                                        <a
                                            :href="item.href"
                                            :arial-label="'Odkaz ' + item.name"
                                            class="text-xs text-gray-200 hover:underline md:text-sm/6"
                                        >
                                            {{ item.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="grid h-full md:gap-8 lg:grid-cols-2">
                            <div>
                                <h3 class="text-left text-sm/6 font-semibold text-white">O nás</h3>
                                <ul
                                    role="list"
                                    class="mt-6 space-y-2 pl-2"
                                >
                                    <li
                                        v-for="item in navigation.abouts"
                                        :key="item.name"
                                    >
                                        <a
                                            :href="item.href"
                                            :arial-label="'Odkaz ' + item.name"
                                            class="text-xs text-gray-200 hover:underline md:text-sm/6"
                                            :target="item.target"
                                            :rel="item.rel"
                                        >
                                            {{ item.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="mt-10 md:mt-0">
                                <h3 class="text-left text-sm/6 font-semibold text-white">Kontakty</h3>
                                <ul
                                    role="list"
                                    class="mt-6 space-y-2 pl-2"
                                >
                                    <li
                                        v-for="item in navigation.contacts"
                                        :key="item.name"
                                    >
                                        <a
                                            :href="item.href"
                                            :arial-label="'Odkaz ' + item.name"
                                            class="text-xs text-nowrap text-gray-200 hover:underline md:text-sm/6"
                                        >
                                            {{ item.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-span-full inline-flex space-x-4">
                            <a
                                v-for="item in navigation.socials"
                                :key="item.name"
                                :href="item.href"
                                target="_blank"
                                rel="noopener noreferrer"
                                :aria-label="'Odkaz na ' + item.name"
                                class="hover:text-brand-orange text-gray-200"
                            >
                                <span class="sr-only">{{ item.name }}</span>
                                <component
                                    :is="item.icon"
                                    class="size-6"
                                    aria-hidden="true"
                                />
                            </a>
                        </div>

                        <div class="col-span-full grid h-full grid-cols-1 gap-8 md:gap-8 lg:grid-cols-2">
                            <div
                                class="inline-flex items-center justify-center space-x-4 lg:items-start lg:justify-start"
                            >
                                <div class="items-center justify-center text-center lg:text-left">
                                    <h3 class="text-center text-sm/6 font-semibold text-white lg:text-left">
                                        Dokumenty a nastavení
                                    </h3>

                                    <ul
                                        role="list"
                                        class="mt-6 space-y-2 pl-2"
                                    >
                                        <li>
                                            <Link
                                                :href="policy.url()"
                                                aria-label="Odkaz na Zásady ochrany osobních údajů"
                                                class="text-xs text-gray-200 hover:underline md:text-sm/6"
                                            >
                                                Zásady ochrany osobních údajů
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                :href="cookies.url()"
                                                aria-label="Odkaz na Zásady používání souborů cookie"
                                                class="text-xs text-gray-200 hover:underline md:text-sm/6"
                                            >
                                                Zásady používání souborů cookie
                                            </Link>
                                        </li>

                                        <li>
                                            <button
                                                type="button"
                                                @click="openCookiePreferences"
                                                class="text-xs text-gray-200 hover:underline md:text-sm/6"
                                                aria-label="Změnit preference souborů cookie"
                                            >
                                                Změnit preference souborů cookie
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="inline-flex space-x-4">
                                <div class="items-center justify-center text-center lg:text-left">
                                    <h3 class="text-center text-sm/6 font-semibold text-white lg:text-left">
                                        Fakturační údaje
                                    </h3>
                                    <ul
                                        role="list"
                                        class="mt-6 space-y-2 pl-2"
                                    >
                                        <li class="text-sm/6 text-gray-200 hover:underline">J&M.Sádrokartony s.r.o.</li>
                                        <li class="text-sm/6 text-gray-200 hover:underline">
                                            Sídlo: Bělkovice-Lašťany 179, 783 16 Bělkovice-Lašťany
                                        </li>
                                        <li class="text-sm/6 text-gray-200 hover:underline">IČO: 23397284</li>
                                        <li class="text-sm/6 text-gray-200 hover:underline">DIČ: CZ23397284</li>
                                        <li class="text-sm/6 text-gray-200 hover:underline">
                                            Spisová značka: C 99929 vedená u Krajského soudu v Ostravě
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="border-brand-orange/50 mt-5 flex flex-col space-y-4 border-t py-5 lg:mt-12 lg:items-center lg:justify-between lg:pt-8 xl:flex-row"
                >
                    <div>
                        <p class="text-center text-sm/6 text-gray-200 md:mt-0 lg:mt-8 lg:text-left">
                            {{ new Date().getFullYear() }} J&M.Sádrokartony s.r.o., všechna práva vyhrazena.
                        </p>
                    </div>

                    <div class="flex w-full flex-col items-center justify-center xl:max-w-lg">
                        <div class="flex w-full flex-col items-center justify-center xl:max-w-lg">
                            <FooterLudwig />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
